import { Col, Form, FormInstance, Select } from 'antd';
import { AxiosError } from 'axios';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GetProductQualities from '~/@core/application/useCases/inputs/product/getProductQualities';
import ProductQuality from '~/@core/domain/model/product/ProductQuality';
import { globalContext } from '~/context/GlobalContext';

interface Props {
  form: FormInstance<any>;
  siteId: number;
  useDescription?: boolean;
  lgQuality?: number;
}

export default function QualitiesSelect(props: Props) {
  const { form, siteId, useDescription, lgQuality } = props;
  const { handlePromiseUseCase, activeAlert } = useContext(globalContext);

  const { t } = useTranslation();
  const [qualities, setQualities] = useState<ProductQuality[]>([]);

  useEffect(() => {
    if (siteId) {
      const getProductQualities = new GetProductQualities();

      handlePromiseUseCase<ProductQuality[], AxiosError>(
        getProductQualities.execute(),
        prodQualities => {
          setQualities(prodQualities);
        },
        error => {
          activeAlert({
            message: JSON.stringify(
              error.response?.data
                ? error.response?.data
                : 'Houve um erro inesperado!'
            ),
            type: 'error',
            timeout: 5000
          });
        }
      );
    }
    onChangeSite();
    resetOnClear(['QualityId']);
  }, [siteId]);

  const resetOnClear = useCallback(
    (fields: string[]) => {
      form.resetFields(fields);
    },
    [form]
  );

  const onChangeSite = useCallback(() => {
    setQualities([]);
  }, []);

  return (
    <Col lg={lgQuality ?? 6}>
      <Form.Item name="QualityId" label={t('generals.quality')}>
        <Select
          placeholder={t('generals.selectPlaceholder')}
          allowClear
          optionFilterProp="children"
          filterOption
          showSearch
        >
          {qualities?.map((quality: ProductQuality) => (
            <Select.Option
              key={useDescription ? quality.description : quality.id}
              value={useDescription ? quality.description : quality.id}
            >
              {quality.description}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
  );
}
